module.exports = __webpack_public_path__ + "static/media/Heebo-Medium.b6403709.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avesco/Heebo-Medium.woff
// module id = 782
// module chunks = 0